export const ownEffect = (fn, arg, target) => {
    return { fn, arg, target };
};
export const ownTaskFilter = (owner) => (task) => {
    var _a;
    if (!task.engine || task.engine == owner) {
        //        console.log('task', task.arg, task.target)
        // исполняем задачу
        (_a = task.fn) === null || _a === void 0 ? void 0 : _a.call(task.target, task.arg);
        task.done = true;
    }
    else {
        return true;
    }
};
export const subscriptionTaskFilter = (subscriptions) => (task) => {
    const engine = subscriptions.find((sub) => sub == task.engine);
    if (engine) {
        engine.queue(task);
    }
    else {
        return true;
    }
};
export const unknownTaskFilter = (subscriptions) => (task) => {
    subscriptions.forEach(sub => {
        sub.queue(task);
    });
};
